import { Link } from "react-router-dom";

const GetStarted = () => {
  return (
    <section className="bg-white py-[48px]">
      <div className="bg-[#EDF8FF] py-[32px]">
        <div className="relative bg-[#084DC5] lg:rounded-[20px] px-3  py-10 md:py-24 overflow-hidden container">
          <div className="absolute left-0 bottom-0">
            <img
              src="https://res.cloudinary.com/analytics-intelligence/image/upload/v1755204903/powerdbyai/Line_pattern_v6mo2z.png"
              alt="Background pattern"
            />
          </div>

          <div className="relative  flex flex-col justify-center items-center gap-3 md:gap-[24px]  text-white text-center">
            <h2 className="text-[22px] lg:text-[44px] font-bold max-w-[717px] mx-auto text-center">
              Ready to Optimize Your Models?
            </h2>

            <p className="text-sm">
              Get enterprise-grade NLP without the enterprise overhead
            </p>

            <Link
              className="border border-primary_alt bg-white px-4 py-2.5 rounded-lg h-max block text-primary_alt font-medium w-max"
              to="/signup"
            >
              Get SLM Solution.
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetStarted;
